
import {createSlice} from "@reduxjs/toolkit";

export const contractSectionSlice = createSlice({
    name: 'contractSectionSlc',
    initialState: {value: {
        id: 0,
            contractId:null,
            parentSectionId: null,
            parentOrdinalNumber: null,
            parentRecordLevel: null,
            parentMcode: null,
            parentName: null,
            parentDescription: null,
            previousSectionId: null,
            previousOrdinalNumber: null,
            previousRecordLevel: null,
            previousMcode: null,
            previousName: null,
            previousDescription: null,
            ordinalNumber: null,
            recordLevel: null,
            mcode:null,
            name: null,
            nameShort: null,
            description: null,
            shortName: null,
            status: null,
            hierarchy: null,
            createdOn: null,
            createdBy:null,
            lastModifiedOn:null,
            lastModifiedBy:null,
            csDrawerState: false,
            csDrawerMode: null,
            csGridRefresh: false,
            csCloningDrawerState: false,
            csGraftingDrawerState: false,
            csTransplantingDrawerState: false,
            drilldownCsId: 0,
            type: null,
            contents: null
        }},
    reducers:
{
    changeContractSection: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractSection } = contractSectionSlice.actions;

export default  contractSectionSlice.reducer ;

